import Immutable from 'immutable';
import createReducers from '../utils/createreducer';
import {
    SYSTEM_LOCATION_CHANGED, SYSTEM_UPDATE_IMAGE_CACHE_BREAKER_VALUE
} from '../constants/actionconstants';
import initialStoreState from '../store/initialstorestate';

const initialState = initialStoreState.system;

export default createReducers(initialState, {
    [SYSTEM_LOCATION_CHANGED] : (state, payload) => {
        return Object.assign({}, state, {
            locationPath: payload.location.pathname
        });
    },
    [SYSTEM_UPDATE_IMAGE_CACHE_BREAKER_VALUE] : (state, payload) => {
        return Object.assign({}, state, {
            imageCacheBreaker: payload.value
        });
    }
});


// WEBPACK FOOTER //
// ./src/client/src/reducers/system.js